/* iceberg-ui */
import { Card, ProgressCircle } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/*  Shared  */
import { RunReportLink } from 'application/Shared/Components/Reports/RunReportLink';
import {
    getScoreFillColor,
    getScoreUnfilledColor
} from 'application/Shared/Reports/ScoreFillColor';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const QBRFirstScoreOverview = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { reportData, reportSetup, withGraph } = props;
    const { startTime, period, type } = reportSetup;

    const scoreArray =
        reportData?.qbrQBRFirstScoreOverview == null
            ? []
            : Object.entries(reportData.qbrQBRFirstScoreOverview).reduce(
                  (acc, [report, value]) => {
                      const { score } = value;

                      /* eslint no-unused-expressions: ["error", { "allowTernary": true }] */
                      report === 'SaaSSophisticationScore'
                          ? acc.unshift({ report, score })
                          : acc.push({ report, score });
                      return acc;
                  },
                  []
              );

    return (
        <Grid container spacing={3}>
            {scoreArray.map((chart) => (
                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={withGraph ? 6 : 4}
                    lg={withGraph ? 6 : 2}
                    key={`${chart.report}`}
                >
                    <RunReportLink
                        startTime={startTime}
                        period={period}
                        reportType={type}
                        userSelection={[0]}
                        run
                    >
                        <Card
                            sx={{ cursor: 'inherit', height: '100%' }}
                            data-testid={`reportsQBRRenderCard${chart.report}`}
                        >
                            <ProgressCircle
                                cursor="pointer"
                                data={[
                                    {
                                        fill: getScoreFillColor({
                                            theme,
                                            value: chart.score
                                        }),
                                        name: chart.report,
                                        value: chart.score
                                    },
                                    {
                                        fill: getScoreUnfilledColor({
                                            theme,
                                            value: chart.score
                                        }),
                                        name: '',
                                        value: 100 - chart.score
                                    }
                                ]}
                                emptyMessage={t('Common.noData')}
                                isAnimationActive
                                responsiveContainerHeight={80}
                                text={chart.score}
                                title={t(`QBR.${chart.report}`)}
                                titleTooltipText={t(
                                    `QBRFirst.definitions.${chart.report}`
                                )}
                            />
                        </Card>
                    </RunReportLink>
                </Grid>
            ))}
        </Grid>
    );
};
